import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconArrowUp = function IconArrowUp(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-arrow-up"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "m18.68 14.28-5.97-5.99a1 1 0 0 0-1.41 0l-5.98 6a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0l5.28-5.29 5.26 5.28a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42"
  }, pathRest)));
};
IconArrowUp.displayName = 'InlineIcon(IconArrowUp)';
IconArrowUp.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconArrowUp };
